import React from 'react';
import HeroSection from '../components/ui/HeroSection';
import CategoryCard from '../components/ui/CategoryCard';
import ProductCard from '../components/ui/ProductCard';
import TestimonialCard from '../components/ui/TestimonialCard';
import CTAButton from '../components/ui/CTAButton';
import { ShieldCheckIcon, TruckIcon, BadgeCheckIcon, HeartIcon } from 'lucide-react';
const HomePage = () => {
  // Featured Categories
  const categories = [{
    id: 'fashion',
    name: 'Fashion & Accessories',
    description: 'Discover trendy clothing, jewelry, and accessories from independent designers.',
    image: 'https://images.unsplash.com/photo-1483985988355-763728e1935b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    productCount: 1245
  }, {
    id: 'home',
    name: 'Home & Living',
    description: 'Beautiful decor, furniture, and home essentials for every space.',
    image: 'https://images.unsplash.com/photo-1556228453-efd6c1ff04f6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    productCount: 876
  }, {
    id: 'electronics',
    name: 'Electronics',
    description: 'The latest gadgets, tech accessories, and electronic innovations.',
    image: 'https://images.unsplash.com/photo-1550009158-9ebf69173e03?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1201&q=80',
    productCount: 543
  }, {
    id: 'handmade',
    name: 'Handmade Crafts',
    description: 'Unique handcrafted items made with care by talented artisans.',
    image: 'https://images.unsplash.com/photo-1452860606245-08befc0ff44b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    productCount: 932
  }];
  // Featured Products
  const products = [{
    id: 'prod1',
    name: 'Handcrafted Leather Wallet',
    price: 49.99,
    image: 'https://images.unsplash.com/photo-1627123424574-724758594e93?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1887&q=80',
    rating: 4.8,
    seller: 'Artisan Leatherworks',
    isNew: true
  }, {
    id: 'prod2',
    name: 'Minimalist Desk Lamp',
    price: 79.99,
    image: 'https://images.unsplash.com/photo-1507473885765-e6ed057f782c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1887&q=80',
    rating: 4.5,
    seller: 'Modern Home Designs',
    discount: 20
  }, {
    id: 'prod3',
    name: 'Organic Cotton T-Shirt',
    price: 29.99,
    image: 'https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1480&q=80',
    rating: 4.6,
    seller: 'EcoFashion'
  }, {
    id: 'prod4',
    name: 'Smart Water Bottle',
    price: 45.0,
    image: 'https://images.unsplash.com/photo-1602143407151-7111542de6e8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1887&q=80',
    rating: 4.3,
    seller: 'TechLife',
    isNew: true
  }, {
    id: 'prod5',
    name: 'Handmade Ceramic Mug',
    price: 24.99,
    image: 'https://images.unsplash.com/photo-1514228742587-6b1558fcca3d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1480&q=80',
    rating: 4.9,
    seller: 'Pottery Studio',
    discount: 10
  }, {
    id: 'prod6',
    name: 'Wireless Earbuds',
    price: 89.99,
    image: 'https://images.unsplash.com/photo-1606220588913-b3aacb4d2f46?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1480&q=80',
    rating: 4.7,
    seller: 'AudioTech'
  }, {
    id: 'prod7',
    name: 'Natural Face Cream',
    price: 34.5,
    image: 'https://images.unsplash.com/photo-1556228578-8c89e6adf883?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1887&q=80',
    rating: 4.4,
    seller: 'Pure Botanicals',
    discount: 15
  }, {
    id: 'prod8',
    name: 'Vintage Wall Clock',
    price: 59.99,
    image: 'https://images.unsplash.com/photo-1592914610354-fd354ea45e48?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1480&q=80',
    rating: 4.6,
    seller: 'Retro Home',
    isNew: true
  }];
  // Testimonials
  const testimonials = [{
    name: 'Sarah Johnson',
    role: 'Customer',
    image: 'https://randomuser.me/api/portraits/women/12.jpg',
    content: "I've found so many unique products on MarketHub that I couldn't find anywhere else. The quality is always excellent!",
    rating: 5
  }, {
    name: 'Michael Chen',
    role: 'Seller',
    image: 'https://randomuser.me/api/portraits/men/22.jpg',
    content: 'As a small business owner, MarketHub has helped me reach customers worldwide. Their seller tools are intuitive and powerful.',
    rating: 5
  }, {
    name: 'Emily Rodriguez',
    role: 'Customer',
    image: 'https://randomuser.me/api/portraits/women/33.jpg',
    content: 'The customer service is outstanding. When I had an issue with an order, they resolved it immediately.',
    rating: 4
  }];
  return <div className="bg-gray-50" data-id="element-522">
      {/* Hero Section */}
      <HeroSection data-id="element-523" />
      {/* Featured Categories */}
      <section className="py-16" data-id="element-524">
        <div className="container mx-auto px-4" data-id="element-525">
          <div className="text-center mb-12" data-id="element-526">
            <h2 className="text-3xl font-bold mb-4" data-id="element-527">Shop by Category</h2>
            <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-528">
              Explore our curated collection of unique products across popular
              categories.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-529">
            {categories.map(category => <CategoryCard key={category.id} id={category.id} name={category.name} description={category.description} image={category.image} productCount={category.productCount} data-id="element-530" />)}
          </div>
          <div className="text-center mt-10" data-id="element-531">
            <CTAButton to="/categories" text="View All Categories" variant="outline" data-id="element-532" />
          </div>
        </div>
      </section>
      {/* Trust Features */}
      <section className="bg-white py-12" data-id="element-533">
        <div className="container mx-auto px-4" data-id="element-534">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-535">
            <div className="flex flex-col items-center text-center p-4" data-id="element-536">
              <div className="bg-blue-100 p-3 rounded-full mb-4" data-id="element-537">
                <ShieldCheckIcon className="h-8 w-8 text-blue-600" data-id="element-538" />
              </div>
              <h3 className="font-semibold text-lg mb-2" data-id="element-539">Secure Shopping</h3>
              <p className="text-gray-600 text-sm" data-id="element-540">
                All transactions are protected with advanced encryption.
              </p>
            </div>
            <div className="flex flex-col items-center text-center p-4" data-id="element-541">
              <div className="bg-blue-100 p-3 rounded-full mb-4" data-id="element-542">
                <BadgeCheckIcon className="h-8 w-8 text-blue-600" data-id="element-543" />
              </div>
              <h3 className="font-semibold text-lg mb-2" data-id="element-544">Verified Sellers</h3>
              <p className="text-gray-600 text-sm" data-id="element-545">
                Every seller is vetted to ensure quality products.
              </p>
            </div>
            <div className="flex flex-col items-center text-center p-4" data-id="element-546">
              <div className="bg-blue-100 p-3 rounded-full mb-4" data-id="element-547">
                <TruckIcon className="h-8 w-8 text-blue-600" data-id="element-548" />
              </div>
              <h3 className="font-semibold text-lg mb-2" data-id="element-549">Fast Delivery</h3>
              <p className="text-gray-600 text-sm" data-id="element-550">
                Quick and reliable shipping on all orders.
              </p>
            </div>
            <div className="flex flex-col items-center text-center p-4" data-id="element-551">
              <div className="bg-blue-100 p-3 rounded-full mb-4" data-id="element-552">
                <HeartIcon className="h-8 w-8 text-blue-600" data-id="element-553" />
              </div>
              <h3 className="font-semibold text-lg mb-2" data-id="element-554">
                Customer Satisfaction
              </h3>
              <p className="text-gray-600 text-sm" data-id="element-555">
                Dedicated support to ensure you're completely happy.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Featured Products */}
      <section className="py-16" data-id="element-556">
        <div className="container mx-auto px-4" data-id="element-557">
          <div className="text-center mb-12" data-id="element-558">
            <h2 className="text-3xl font-bold mb-4" data-id="element-559">Featured Products</h2>
            <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-560">
              Discover our handpicked selection of unique products from trusted
              sellers.
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-561">
            {products.map(product => <ProductCard key={product.id} id={product.id} name={product.name} price={product.price} image={product.image} rating={product.rating} seller={product.seller} discount={product.discount} isNew={product.isNew} data-id="element-562" />)}
          </div>
          <div className="text-center mt-10" data-id="element-563">
            <CTAButton to="/categories" text="Explore All Products" data-id="element-564" />
          </div>
        </div>
      </section>
      {/* Seller CTA */}
      <section className="bg-gradient-to-r from-blue-600 to-blue-800 py-16 text-white" data-id="element-565">
        <div className="container mx-auto px-4" data-id="element-566">
          <div className="max-w-3xl mx-auto text-center" data-id="element-567">
            <h2 className="text-3xl font-bold mb-4" data-id="element-568">
              Start Selling on MarketHub
            </h2>
            <p className="text-xl mb-8" data-id="element-569">
              Join thousands of successful sellers and reach customers
              worldwide. Low fees, powerful tools, and dedicated support.
            </p>
            <CTAButton to="/become-seller" text="Become a Seller" variant="secondary" size="lg" data-id="element-570" />
          </div>
        </div>
      </section>
      {/* Testimonials */}
      <section className="py-16 bg-gray-50" data-id="element-571">
        <div className="container mx-auto px-4" data-id="element-572">
          <div className="text-center mb-12" data-id="element-573">
            <h2 className="text-3xl font-bold mb-4" data-id="element-574">What People Say</h2>
            <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-575">
              Don't just take our word for it. Here's what our community has to
              say.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-576">
            {testimonials.map((testimonial, index) => <TestimonialCard key={index} name={testimonial.name} role={testimonial.role} image={testimonial.image} content={testimonial.content} rating={testimonial.rating} data-id="element-577" />)}
          </div>
        </div>
      </section>
      {/* Newsletter */}
      <section className="py-16 bg-white" data-id="element-578">
        <div className="container mx-auto px-4" data-id="element-579">
          <div className="max-w-3xl mx-auto text-center" data-id="element-580">
            <h2 className="text-3xl font-bold mb-4" data-id="element-581">Stay Updated</h2>
            <p className="text-gray-600 mb-8" data-id="element-582">
              Subscribe to our newsletter for the latest products, exclusive
              deals, and marketplace updates.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-583">
              <input type="email" placeholder="Your email address" className="px-4 py-3 rounded-full border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent flex-grow max-w-md" data-id="element-584" />
              <button className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-full font-medium transition duration-200" data-id="element-585">
                Subscribe
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>;
};
export default HomePage;